module.exports = __webpack_public_path__ + "static/media/uib5.e9017256.png";